import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { HomeFacade } from '@zero/home/domain';
import { InstrumentType } from '@zero/shared/util-models';
import { commonRoutes, famousIndications } from 'constants/web-app-constants';
import { MyMarketOverviewItemComponent } from '../my-market-overview-item/my-market-overview-item.component';
import { IndicationTab } from './indication-tab.model';
import { IndicationTabPipe } from './indication-tab.pipe';

@Component({
  selector: 'home-my-market-overview',
  templateUrl: './my-market-overview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MyMarketOverviewItemComponent, AsyncPipe, TranslocoPipe, IndicationTabPipe],
})
export class MyMarketOverviewComponent implements OnInit, OnDestroy {
  public readonly productsSearchPage = commonRoutes.prelogin.tradeableproducts;
  public homeFacade: HomeFacade = inject(HomeFacade);
  public readonly InstrumentType = InstrumentType;

  public tabs: IndicationTab[] = [];
  public activeTab: IndicationTab = null;

  public ngOnInit(): void {
    this.homeFacade.loadIndications(famousIndications);
    this.homeFacade.subscribeToIndicationQuotes();
    this.#setTabs();
  }

  public ngOnDestroy(): void {
    this.homeFacade.unsubscribeFromIndicesQuotes();
  }

  #setTabs = (): void => {
    this.tabs = [
      {
        identfier: 'my-home.my-market-overview.overview',
        types: [],
      },
      {
        identfier: 'my-home.my-market-overview.indices',
        types: [InstrumentType.Index],
      },
      {
        identfier: 'my-home.my-market-overview.commodities-fx',
        types: [InstrumentType.Commodity, InstrumentType.Currency, InstrumentType.Crypto],
      },
    ];
    this.activeTab = this.tabs[0];
  };
}
